/** ESCHER FALLS — ภาษาไทย。 */

import type { Strings } from './ja';

export const TH: Strings = {
  pour: 'ปล่อยน้ำ',
  lever: 'คันโยก',
  leverAria: 'โยกคันโยก',
  retry: 'เริ่มใหม่',
  again: 'อีกครั้ง',
  next: 'ต่อไป',
  share: 'แบ่งปันภาพนี้',
  shareFailed: 'แบ่งปันไม่ได้',
  rotateLeft: 'หมุนมุมมองไปทางซ้าย',
  rotateRight: 'หมุนมุมมองไปทางขวา',
  tiltUp: 'ยกมุมมองขึ้น',
  tiltDown: 'ลดมุมมองลง',
  topDown: 'จากด้านบน',
  water: (left, total) => `น้ำ ${left} / ${total}`,
  moves: (left, total) => `การหมุน ${left} / ${total}`,
  timeLeft: (time) => `เหลือ ${time}`,
  drops: (n) => `หยดน้ำ ${n}`,

  resultClear: 'น้ำไหลผ่าน',
  resultFail: 'น้ำไม่ไหลผ่าน',
  clearTitle: 'น้ำไหลผ่านแล้ว',
  fail: {
    time: 'หมดเวลา',
    moves: 'หมดจำนวนการหมุน',
    drywell: 'น้ำไหลลงบ่อแห้ง',
    water: 'น้ำหมด',
    deadend: 'น้ำตกลงทางตัน',
  },
  extendByAd: 'ดูโฆษณาเพื่อต่อเวลา 30 วินาที',
  extendByDrops: (cost) => `ใช้ ${cost} หยดเพื่อต่อเวลา 30 วินาที`,
  multiplyByAd: (mult) => `ดูโฆษณารับหยดน้ำ ×${mult}`,

  stages: 'ด่าน',
  settingsAria: 'ตั้งค่า',
  menuAria: 'เมนู',
  back: 'กลับ',
  loop1: 'รอบแรก',
  loop2: 'รอบสอง',
  loopNote: 'รอบสองจำกัดการหมุนและเวลามากขึ้น สถิติจะเก็บแยกจากรอบแรก',
  shop: 'ร้านค้า',
  groupMain: 'ด่านหลัก',
  groupExtra1: 'ด่านพิเศษ',
  groupExtra2: 'ด่านพิเศษ ชุดที่ 2',
  freeTrial: 'ฟรี',
  notPurchased: (n, name) => `${n} ${name} (ยังไม่ได้ซื้อ)`,
  lockedStage: 'ด่านที่ยังไม่เปิด',
  extraLockedFree: 'ด่าน 1 “น้ำตกย้อนกลับ” เล่นได้ฟรี ด่านที่เหลือเปิดเมื่อซื้อจากการตั้งค่า (≡)',
  extraLocked: 'เปิดเมื่อซื้อจากการตั้งค่า (≡)',
  extra2Locked: 'ตั้งแต่ด่านที่ 11 จะเปิดเมื่อน้ำไหลผ่านด่าน 1–10 ทั้งหมด',
  extra2LockedUnowned: 'ซื้อจากการตั้งค่า (≡) แล้วผ่านด่าน 1–10 ทั้งหมดเพื่อเปิดตั้งแต่ด่านที่ 11',
  extra2Note: 'เปิดเมื่อน้ำไหลผ่านด่านพิเศษทั้งหมด',
  progress: (cleared, total) => `ด่านหลัก ${cleared} / ${total} ผ่านแล้ว`,
  totalTime: (time) => `รวม ${time}`,
  totalNone: 'รวม —',

  settings: 'ตั้งค่า',
  bgm: 'เสียงบรรยากาศ',
  se: 'เสียงประกอบ',
  testSound: 'ลองฟังเสียง',
  audioStatus: (state) => `สถานะเสียง: ${state}`,
  audioState: {
    locked: 'ยังไม่เปิด (แตะหน้าจอหนึ่งครั้ง)',
    running: 'กำลังเล่น',
    suspended: 'หยุดชั่วคราว',
  },
  demoNote: (n) => `${n} ด่านนี้คือเวอร์ชันทดลองบนเว็บ ทั้ง 42 ด่านอยู่ในแอป`,
  demoGet: 'ดาวน์โหลดใน App Store',
  // — 今日の一面（日替わり）
  dailyTitle: 'ด่านประจำวัน',
  dailyLoading: 'กำลังโหลด…',
  dailyOffline: 'เชื่อมต่อไม่ได้ จึงเปิดด่านประจำวันไม่ได้',
  dailyPlay: 'เล่น',
  dailyCleared: (time: string) => `ผ่านแล้ว ${time}`,
  archiveTitle: 'ด่านที่ผ่านมา',
  upcomingTitle: 'ด่านล่วงหน้า',
  archiveLocked: '3 วันล่าสุดเล่นฟรี ซื้อด่านพิเศษเพื่อเปิดด่านเก่ากว่านั้นทั้งหมด',
  language: 'ภาษา',
  languageAuto: 'ตามการตั้งค่าเครื่อง',
  palette: 'ชุดสี',
  worn: 'ใช้อยู่',
  owned: 'มีอยู่แล้ว',
  buyDrops: 'ซื้อหยดน้ำ',
  restore: 'กู้คืนการซื้อ',
  writeReview: 'ให้คะแนนแอปนี้',
  moreApps: 'ผลงานอื่นของผู้สร้าง',
  restoreChecking: 'กำลังตรวจสอบ…',
  restoreDone: (n) => `กู้คืนแล้ว ${n} รายการ`,
  restoreNone: 'ไม่มีรายการที่ต้องกู้คืน',
  restoreFailed: 'กู้คืนไม่ได้',
  chooseStage: 'เลือกด่าน',
  resume: 'เล่นต่อ',

  prizeLabel: 'รางวัล',
  awardLabel: 'ฉายา',
  toExtra: 'ไปด่านพิเศษ',
  toLoop2: 'ไปรอบสอง',
  toStart: 'กลับไปจุดเริ่ม',
  allClearTitle: 'ผ่านทั้งหมด',
  allClearBody: (n) => `น้ำไหลผ่านทางน้ำทั้ง ${n} เส้นแล้ว`,
  multiplyTimes: (mult) => `ดูโฆษณารับ ×${mult}`,
  noteRank: 'ฉายาจะถูกบันทึกไว้ และแสดงเหนือรายชื่อด่าน',
  noteLoop2: 'รอบสองเปิดแล้ว การหมุนและเวลาจำกัดมากขึ้น',
  notePartOne: 'จบภาคหนึ่งเพียงเท่านี้ น้ำยังไม่ได้ไหลขึ้น',
  inviteTry: 'ลองด่านพิเศษ 1',
  inviteOpen: 'เปิดด่านพิเศษ ชุดที่ 1 — 20 ด่าน',
  dateLine: (d) =>
    `${d.getDate()} ${['มกราคม','กุมภาพันธ์','มีนาคม','เมษายน','พฤษภาคม','มิถุนายน','กรกฎาคม','สิงหาคม','กันยายน','ตุลาคม','พฤศจิกายน','ธันวาคม'][d.getMonth()]} ${d.getFullYear()}`,

  completionTitle: 'ผู้ข้ามความไม่สิ้นสุด',
  rank: {
    none: '—',
    sovereign: 'ผู้ครองสายน้ำ',
    architect: 'ผู้ออกแบบน้ำตก',
    mason: 'ช่างหิน',
    apprentice: 'ผู้ฝึกหัด',
    wayfarer: 'ผู้เดินทาง',
  },

  skin: {
    hakushi: 'กระดาษเปล่า',
    ai: 'สีคราม',
    koke: 'สีมอส',
    shu: 'สีแดงชาด',
    sumi: 'หมึกซูมิ',
  },

  product: {
    drops600: 'หยดน้ำ 600',
    drops1600: 'หยดน้ำ 1,600',
    drops5000: 'หยดน้ำ 5,000',
    noads: 'ลบโฆษณา',
    extras: 'ด่านพิเศษ ชุดที่ 1 — 21 ด่าน (ไม่มีโฆษณา)',
  },
};
